import { Component, Inject, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent {
  @ViewChild('motivo') motivoNgModel!: NgModel;
  modalTitle: string = '';
  modalContent: string = '';
  confirmButtonText: string = 'Confirmar';
  cancelButtonText: string = 'Cancelar';
  showTextArea: boolean = false;
  textAreaValue: string = '';
  showCheckbox: boolean = false;
  checkboxValue: boolean = true;
  errorText: string = '';

  constructor(
    public dialogRef: MatDialogRef<ModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.modalTitle = this.data.modalTitle ? this.data.modalTitle : '';
    this.modalContent = this.data.modalContent ? this.data.modalContent : '';
    this.showTextArea = this.data.showTextArea ? this.data.showTextArea : false;
    this.showCheckbox = this.data.showCheckbox ? this.data.showCheckbox : false;
  }

  close(): void {
    this.dialogRef.close();
  }

  onPerformAction(): void {
    if (this.data && this.data.onPerformAction) {
      this.performAction();
    }
  }

  private performAction() {
    if (this.showTextArea && !this.textAreaValue.trim()) {
      this.errorText = 'Este campo é obrigatório.';
      this.motivoNgModel.control.markAsTouched();
      return;
    }

    this.data.onPerformAction(
      this.data.id,
      this.textAreaValue,
      this.checkboxValue
    );
    return this.dialogRef.close();
  }
}
